export enum LoginFormState {
    FillIn,
    Login,
    Send,
    Validating,
    Error,
    ValidatingPin
}
